import { render, staticRenderFns } from "./NewQuestion.vue?vue&type=template&id=b4250348&scoped=true"
import script from "./NewQuestion.vue?vue&type=script&lang=js"
export * from "./NewQuestion.vue?vue&type=script&lang=js"
import style0 from "./NewQuestion.vue?vue&type=style&index=0&id=b4250348&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4250348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4250348')) {
      api.createRecord('b4250348', component.options)
    } else {
      api.reload('b4250348', component.options)
    }
    module.hot.accept("./NewQuestion.vue?vue&type=template&id=b4250348&scoped=true", function () {
      api.rerender('b4250348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NewQuestion.vue"
export default component.exports